var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupeeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69889 2.45082H11.7887L12.916 0.5H2.0434L0.916044 2.45082H5.09219C6.01315 2.72844 6.76174 3.2859 7.17564 3.99348H2.0434L0.916016 5.9443H7.43029C7.04393 7.27651 5.54985 8.26944 3.76433 8.26944H1.53742V10.0276L7.85651 15.5H10.608V14.8197L4.83359 9.93172C7.25677 9.83354 9.23633 8.13822 9.59881 5.94427H11.7887L12.916 3.99345H9.48622C9.32502 3.43051 9.05493 2.90984 8.69889 2.45082Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeBlack);
export default __webpack_public_path__ + "static/media/RupeeBlack.eb2b0a569d86500cf830752560c04492.svg";
export { ForwardRef as ReactComponent };